import { useState } from "react";
import { Collapse } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";
import CTA from "@/components/atoms/CTA";
import styles from "./styles.module.css";

/**
 * Site-wide notice shown while the current company has a trade lock. Mounted inside `HeadersContainer` so it
 * stays visible while scrolling.
 */
function TradeLockBanner() {
  const { t } = useTranslation();
  const { isCurrentCompanyLocked } = useAuth();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isCurrentCompanyLocked) return null;

  return (
    <div className={styles.bannerRoot} data-testid="trade-lock-banner" role="status">
      <div className={styles.inner}>
        <div className={styles.row}>
          <SVGAsset name="warning-triangle" className={styles.icon} width="20" height="20" alt="" />

          <Text size="md" strong={true} className={styles.title}>
            {t("company:tradeLock.bannerTitle")}
          </Text>

          <CTA
            intent="tertiary"
            size="sm"
            className={styles.toggle}
            data-testid="trade-lock-banner-toggle"
            aria-expanded={isExpanded}
            onClick={() => setIsExpanded((expanded) => !expanded)}
          >
            {isExpanded ? t("actions:showLess") : t("actions:showMore")}
          </CTA>
        </div>

        <Collapse expanded={isExpanded}>
          <div className={styles.detail}>
            <Text size="sm">{t("company:tradeLock.bannerBody")}</Text>
            <Text size="sm">
              <a href="mailto:info@reviver.no">info@reviver.no</a>
            </Text>
          </div>
        </Collapse>
      </div>
    </div>
  );
}

export default TradeLockBanner;
